import api from './api';

const videoService = {
  // Create video (Authenticated)
  createVideo: async (videoData) => {
    try {
      const formData = new FormData();
      
      // Append all fields to FormData
      Object.keys(videoData).forEach(key => {
        if (videoData[key] !== null && videoData[key] !== undefined) {
          formData.append(key, videoData[key]);
        }
      });

      const response = await api.post('/videos', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to create video' };
    }
  },

  // Get all videos for admin (Authenticated)
  getAdminVideos: async (page = 1, limit = 10) => {
    try {
      const response = await api.get(`/videos?page=${page}&limit=${limit}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to fetch videos' };
    }
  },

  // Get all public videos (No authentication required)
  getPublicVideos: async (page = 1, limit = 10) => {
    try {
      const response = await api.get(`/videos/public?page=${page}&limit=${limit}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to fetch videos' };
    }
  },

  // Get video by ID (No authentication required)
  getVideoById: async (id) => {
    try {
      const response = await api.get(`/videos/public/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to fetch video' };
    }
  },

  // Update video (Authenticated)
  updateVideo: async (id, videoData) => {
    try {
      const formData = new FormData();
      
      // Append all fields to FormData
      Object.keys(videoData).forEach(key => {
        if (videoData[key] !== null && videoData[key] !== undefined) {
          formData.append(key, videoData[key]);
        }
      });

      const response = await api.put(`/videos/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to update video' };
    }
  },

  // Delete video (Authenticated)
  deleteVideo: async (id) => {
    try {
      const response = await api.delete(`/videos/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to delete video' };
    }
  },

  // Generate thumbnail from YouTube URL (Authenticated)
  generateThumbnail: async (url) => {
    try {
      const response = await api.post('/videos/generate-thumbnail', { url });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to generate thumbnail' };
    }
  }
};

export default videoService;
